var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"d-flex",attrs:{"height":"100"}},_vm._l((_vm.menus),function(item,index){return _c('v-sheet',{key:item.key,staticClass:"tabItem",on:{"click":() => _vm.selectTab(index)}},[_c('img',{attrs:{"src":require(`@/assets/menus/${_vm.getMenuIcon(item.key, _vm.selected === index)}`)}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }